import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { IMAGE_SIZES } from '../../../../../../../utils/helpers/imageHelper';
import Picture from '../../../../../../common/picture/Picture';

const ImageThumbnails = (props) => {
  const { images, currentImageIndex, setCurrentImageIndex } = props;
  const [showAllImages, setShowAllImages] = useState(false);

  const firstThreeImages = images.slice(0, 3);

  let displayImages = firstThreeImages;
  if (showAllImages) {
    displayImages = images;
  }

  useEffect(() => {
    if (currentImageIndex > 2) {
      setShowAllImages(true);
    }
  }, [currentImageIndex]);

  return (
    <div>
      <StyledImageThumbnails>
        {displayImages.map((image, index) => (
          <StyledPictureWrapper
            key={image.image}
            selected={currentImageIndex === index}
            onClick={() => setCurrentImageIndex(index)}
          >
            <Picture
              src={image.image}
              alt={image.caption}
              size={IMAGE_SIZES.THUMB}
              height={107}
            />
          </StyledPictureWrapper>
        ))}
      </StyledImageThumbnails>
      {images.length > 3 && (
        <StyledViewImagesButton
          onClick={() => setShowAllImages((show) => !show)}
        >
          {showAllImages ? 'View less images' : 'View all images'}
        </StyledViewImagesButton>
      )}
    </div>
  );
};

const StyledImageThumbnails = styled.div`
  flex-basis: auto;

  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.mediumUp} {
    flex-direction: column;
    flex-wrap: nowrap;
  }
  @media ${({ theme }) => theme.xLargeUp} {
    flex-basis: 24%;
  }
`;

const StyledPictureWrapper = styled.div`
  ${({ selected }) =>
    selected
      ? 'border: 1px solid var(--blue-light);'
      : 'border: 1px solid transparent;'}

  cursor: pointer;
`;

const StyledViewImagesButton = styled.button`
  background-color: transparent;
  color: var(--blue-base);
  border: none;
  padding: 0;
  margin: 5px 0 0 0;
  font-size: 15px;
  text-align: start;
`;

export default ImageThumbnails;
